<template>

  <div v-if="currentCompetition" class="edit-form">
    <h4>Stevne</h4>
    <form>
      <div class="form-group">
        <label for="title">Navn</label>
        <input type="text" class="form-control" id="title"
          v-model="currentCompetition.name"
        />
      </div>
      <div class="form-group">
        <label for="date_start">Dato start</label>
        <input type="text" class="form-control" id="date_start"
          v-model="currentCompetition.date_start"
        />
      </div>
      <div class="form-group">
        <label for="date_end">Dato slutt</label>
        <input type="text" class="form-control" id="date_end"
          v-model="currentCompetition.date_end"
        />
      </div>
      <div class="form-group">
        <label for="level">Nivå</label>
        <input type="text" class="form-control" id="level"
          v-model="currentCompetition.level"
        />
      </div>
      <div class="form-group">
        <label for="organizer">Arrangør</label>
        <input type="text" class="form-control" id="organizer"
          v-model="currentCompetition.organizer"
        />
      </div>
      <div class="form-group">
        <label for="external_webpage">Web</label>
        <input type="text" class="form-control" id="external_webpage"
          v-model="currentCompetition.external_webpage"
        />
      </div>
      <div class="form-group">
        <label for="venue_id">Stadion</label>
        <input type="text" class="form-control" id="venue_id"
          v-model="currentCompetition.venue_id"
        />
      </div>
      <div class="form-group">
        <label for="affiliation_field">Tilhørighet</label>
        <input type="text" class="form-control" id="affiliation_field"
          v-model="currentCompetition.affiliation.field"
        />
        <input type="text" class="form-control" id="affiliation_title"
          v-model="currentCompetition.affiliation.title"
        />
      </div>
      <div class="form-group">
        <label for="publishDate">Publiseringsdato</label>
        <input type="text" class="form-control" id="publishDate"
          v-model="currentCompetition.publishDate"
        />
      </div>
    <div class="form-group">
        <label for="hideMissingCallroomAfterFirstResult">Skjul manglende opprop etter første resultat</label>
        <input type="checkbox" id="hideMissingCallroomAfterFirstResult"
          v-model="currentCompetition.hideMissingCallroomAfterFirstResult"
        />
      </div>
      <div class="form-group">
        <label for="email_body">Epost hovedtekst</label>
        <textarea v-model="currentCompetition.email_body" cols="110" rows="10">
        </textarea>
      </div>

      <div class="form-group">
        <label><strong>Admin godkjennelse:</strong></label>
        {{ currentCompetition.adminApproved ? "Godkjent" : "Venter" }}
      </div>
    </form>

    <button class="badge badge-primary mr-2"
      v-if="currentCompetition.adminApproved"
      @click="updatePublished(false)"
    >
      Fjern godkjennelse
    </button>
    <button v-else class="badge badge-primary mr-2"
      @click="updatePublished(true)"
    >
      Godkjenn stevne
    </button>

    <button class="badge badge-danger mr-2"
      @click="deleteCompetition"
    >
      Slett stevne
    </button>

    <button type="submit" class="badge badge-success"
      @click="updateCompetition"
    >
      Oppdater stevne
    </button>
    <p>{{ message }}</p>
  </div>

  <div v-else>
    <br />
    <p>Please click on a Competition...</p>
  </div>
</template>

<script>
import CompetitionDataService from "../services/CompetitionDataService";

export default {
  name: "competition",
  data() {
    return {
      currentCompetition: null,
      message: ''
    };
  },
  methods: {
    getCompetition(id) {
      CompetitionDataService.get(id)
        .then(response => {
          this.currentCompetition = response.data[0];
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updatePublished(status) {
      // var data = {
      //   id: this.currentCompetition._id,
      //   title: this.currentCompetition.title,
      //   description: this.currentCompetition.description,
      //   published: status
      // };
      this.currentCompetition.adminApproved=status

      CompetitionDataService.update(this.currentCompetition.id, this.currentCompetition)
        .then(response => {
          this.currentCompetition.adminApproved = status;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateCompetition() {
      CompetitionDataService.update(this.currentCompetition.id, this.currentCompetition)
        .then(response => {
          console.log(response.data);
          this.message = 'The competition was updated successfully!';
        })
        .catch(e => {
          console.log(e);
        });
    },

    deleteCompetition() {
      CompetitionDataService.delete(this.currentCompetition.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "competitions" });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  filters: {
    formatDate_onlyDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString("no-NO", { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  },
  mounted() {
    console.log("Competition - mounted")
    this.message = '';
    this.getCompetition(this.$route.params.competition_id);
  }
};
</script>

<style>
.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
